import type { GetMeterDescriptionResponse } from '@vy/api-definition';
import { GetMeterDescriptionResponseSchema } from '@vy/api-definition';
import type { MeterInput } from '@vy/types';
import { vySerialize } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useProductDescription(
  meterInput: MeterInput,
  options?: CustomUseQueryOptions<GetMeterDescriptionResponse>,
) {
  return useQuery(
    queryKeys.productDescription(vySerialize(meterInput)),
    async ({ signal }) => {
      const api = getPrivateApi();

      const response = await api.getMeterDescription(
        {
          getMeterDescriptionRequest: {
            meter: meterInput,
          },
        },
        { signal },
      );

      return GetMeterDescriptionResponseSchema.parse(response);
    },
    options,
  );
}
